export enum B2bFirstOrderDiscount {
	Off = "Off",
	On = "On",
	Used = "Used",
}
